module.exports = __webpack_public_path__ + "static/media/cash grey.3c29db28.svg";